export function ContactPage() {
  return (
    <section aria-labelledby="contact-title">
      <h1 id="contact-title">Contact Us</h1>
    </section>
  )
}
